import {faTrash} from '@fortawesome/pro-solid-svg-icons';
import {type ReactAction} from '@netx/core/bootstrap';
import {canDeleteAssetViews} from '../enablers';
import {AssetViewActionLabel} from '../locales';
import {type IAsset} from '@netx/core-asset-next/schema';
import {type IAssetView} from '../schema';

export const assetViewActionDeleteIcon = faTrash;

export interface AssetViewActionDeleteParams extends Partial<ReactAction> {}

/**
 * Delete asset view
 * @param params
 * @returns Action
 */
export const assetViewActionDelete = (
	asset: IAsset,
	view: IAssetView,
	params: AssetViewActionDeleteParams = {},
): ReactAction => ({
	name: 'asset-view-delete',
	cb: () => {},
	enableTest: () => canDeleteAssetViews(asset, view),
	icon: assetViewActionDeleteIcon,
	get label() {
		return AssetViewActionLabel.DELETE;
	},
	...params,
});
